import { useSelector } from 'react-redux';
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { DealState } from '@makemydeal/dr-dash-types';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

import { TOTAL_AMOUNT_DUE } from '../../constants';
import { createDealRootSelector } from '../../offerCompareColumn/hooks/createDealRootSelector';
import DealSummaryItem from '../common/DealSummaryItem';

// hooks
import { useDealSummary } from '../../common/DealSummaryProvider';

// styles
import { detailedViewValueStyles } from '../utils/styles';

// utils
import { getTotalAmountDueSelector } from '../utils/getTotalAmountDueSelector';

export type TotalAmountDueProps = DealState & {
    showLargeValue?: boolean;
    hasDelta?: boolean;
    logCashBreakdown?: boolean;
};

const TotalAmountDue = ({ deal, showLargeValue, hasDelta = false, logCashBreakdown }: TotalAmountDueProps) => {
    const useDealRootSelector = createDealRootSelector(deal, 'TotalAmountDue');
    const isCashReduxTelemetryEnabled = useSelector(featureToggleSelectors.isCashReduxTelemetryEnabled);
    const totalAmountDue = useDealRootSelector(
        getTotalAmountDueSelector(deal),
        'totalAmountDue',
        logCashBreakdown && isCashReduxTelemetryEnabled ? { context: 'cashBreakdown', contextArg: deal } : undefined
    );
    const { showDetailedView } = useDealSummary();

    return (
        <DealSummaryItem
            label={TOTAL_AMOUNT_DUE}
            value={formatDollarsAndCents(totalAmountDue)}
            showLargeValue={showLargeValue}
            hasDelta={hasDelta}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default TotalAmountDue;
